 $(function () {


        console.log('slick-seting');

        // $('.slider').slick();
        // $(".slider").slick({

        // });
        $('.slider').on('init', function (event, slick) {
            $(this).append('<div class="slick-counter"><span class="current"></span> / <span class="total"></span></div>');
            $(this).find('.total').text(slick.slideCount);
            $(this).find('.current').text(slick.currentSlide + 1);
        }).slick({
            dots: false,
            adaptiveHeight: true,
            prevArrow: '<button class="slide-arrow prev-arrow"><img src="./jojo3/sp/img/prev.png"></button>',
            nextArrow: '<button class="slide-arrow next-arrow"><img src="./jojo3/sp/img/next.png"></button>'
        })
            .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                $(this).find('.current').text(nextSlide + 1);
            });

        $(".slider-item").slick({
            infinite: true,
            dots: false,
            adaptiveHeight: true,
            arrows: false,
            dotsClass: 'slide-dots',
            slidesToShow: 1,
            centerMode: true, //要素を中央寄せ
            centerPadding: '80px', //両サイドの見えている部分のサイズ
        });

    });